import React from 'react';

const LoadingEditComponent = () => {
    return (
        <div className="h-14 flex justify-center items-center">
            <div className="loader-edit"></div>
        </div>
    );
};

export default LoadingEditComponent;